import type { Meta, StoryObj } from "@storybook/react";

import type { UserOverviewCardProps } from "@/ui/components/profile";
import { UserOverviewCard } from "@/ui/components/profile";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<UserOverviewCardProps> = {
  title: "Components/Profile/User Overview",
  component: UserOverviewCard,
  argTypes: {
    address: { control: "text" },
    contactPreferences: { control: "text" },
    fullName: { control: "text" },
    gender: { control: "text" },
    languages: { control: "text" },
    phoneNumber: { control: "text" },
    pronouns: { control: "object" },
    shouldDisplayMissingFields: { control: "boolean" },
    userType: {
      control: "select",
      options: Object.values(["patient", "provider", "support"]),
    },
  },
  args: {
    address: "1241 Main St.\nLos Angeles, CA 11201",
    contactPreferences: "Phone, Email",
    fullName: "Charlotte Washington",
    gender: "Cis-gender female",
    languages: "English, Spanish",
    phoneNumber: "(432) 832-1837",
    pronouns: ["she/her"],
    shouldDisplayMissingFields: true,
    userType: "patient",
  },
  render: (props) => (
    <Box width="100%">
      <UserOverviewCard {...props} />
    </Box>
  ),
};

type Story = StoryObj<UserOverviewCardProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
